<template>
  <v-dialog
    id="employee-modal-form"
    ref="employeeModalForm"
    v-model="$store.state.employeeModalFormOpen"
    :disabled="!isPermittedAll(['EmployeesGeyByID'])"
    width="800"
    persistent
    no-click-animation>
    <form
      @submit.prevent="saveEmployee">
      <v-container
        class="px-5 pb-2 pt-0">
        <!-- Title -->
        <v-row>
          <v-col
            class="d-flex pr-0">
            <h2>
              <span
                v-if="$store.getters.isActiveEmployeeDirty">
                *
              </span>
              <span
                v-if="activeEmployee.EmployeeID">
                Edit
              </span>
              <span
                v-else>
                Add
              </span>
              Employee
              <span
                v-if="activeEmployee.EmployeeID">
                #{{activeEmployee.EmployeeID}}
              </span>
            </h2>
            <v-btn
              class="square ml-auto"
              type="button"
              text
              @click="closeEmployeeModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Title -->

        <!-- Name -->
        <v-row>
          <v-col>
            <v-text-field
              id="employee-name"
              name="employeeName"
              ref="employeeName"
              v-model="activeEmployee.EmployeeName"
              label="Name:"
              :readonly="$store.getters.isLoadingActive"
              hide-details>
            </v-text-field>
          </v-col>
        </v-row>
        <!-- / Name -->

        <v-row>
          <v-col>
            <!-- Title -->
            <v-row>
              <v-col class="pt-0">
                <Autocomplete
                  id="employee-title"
                  label="Title:"
                  v-model="employeeTitle"
                  :items="$store.state.employeeTitles"
                  item-value="EmployeeTitleID"
                  item-text="EmployeeTitleName">
                </Autocomplete>
              </v-col>
            </v-row>
            <!-- / Title -->

            <!-- Phone 1 -->
            <v-row>
              <v-col>
                <v-text-field
                  id="employee-phone1"
                  name="employeePhone1"
                  ref="employeePhone1"
                  v-model="activeEmployee.EmployeePhone1"
                  label="Phone 1:"
                  :readonly="$store.getters.isLoadingActive"
                  hide-details>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- / Phone 1 -->

            <!-- Phone 2 -->
            <v-row>
              <v-col>
                <v-text-field
                  id="employee-phone2"
                  name="employeePhone2"
                  ref="employeePhone2"
                  v-model="activeEmployee.EmployeePhone2"
                  label="Phone 2:"
                  :readonly="$store.getters.isLoadingActive"
                  hide-details>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- / Phone 2 -->

            <!-- Fax -->
            <v-row>
              <v-col>
                <v-text-field
                  id="employee-fax"
                  name="employeeFax"
                  ref="employeeFax"
                  v-model="activeEmployee.EmployeeFax"
                  label="Fax:"
                  :readonly="$store.getters.isLoadingActive"
                  hide-details>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- / Fax -->

            <!-- Email -->
            <v-row>
              <v-col>
                <v-text-field
                  id="employee-email"
                  name="employeeEmail"
                  ref="employeeEmail"
                  v-model="activeEmployee.EmployeeEmail"
                  label="Email:"
                  :readonly="$store.getters.isLoadingActive"
                  hide-details>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- / Email -->
          </v-col>

          <!-- Notes -->
          <v-col :cols="isMobile ? 12 : 6">
            <label
              for="employee-notes">
              Notes:
            </label>
            <v-textarea
              id="employee-notes"
              name="employeeNotes"
              rows="12"
              v-model="activeEmployee.EmployeeNotes"
              :readonly="$store.getters.isLoadingActive"
              hide-details
              no-resize>
            </v-textarea>
          </v-col>
          <!-- / Notes -->
        </v-row>

        <!-- Buttons -->
        <v-row>
          <v-col class="d-flex justify-end">
            <LastModifiedBy
                :entity="activeEmployee"
              />
          </v-col>
          <v-col
            class="d-flex align-center">

            <v-btn
              v-if="isPermittedToSave"
              class="ml-auto"
              type="submit"
              color="primary"
              :disabled="$store.getters.isLoadingActive
                || !$store.getters.isActiveEmployeeDirty">
              Save
            </v-btn>

            <v-btn
              v-if="activeEmployee.EmployeeID
                && isPermittedAll([
                  'EmployeesDelete',
                ])
                && !activeEmployee.EmployeeIsDeleted"
              type="button"
              color="error"
              class="order-first mr-5"
              outlined
              @click="hideEmployee"
              :disabled="$store.getters.isLoadingActive">
              Hide Employee
            </v-btn>

            <v-btn
              v-if="activeEmployee.EmployeeID
                && isPermittedAll([
                  'EmployeesRestore',
                ])
                && activeEmployee.EmployeeIsDeleted"
              type="button"
              color="error"
              class="order-first mr-5"
              outlined
              @click="restoreEmployee"
              :disabled="$store.getters.isLoadingActive">
              Unhide Employee
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Buttons -->
      </v-container>
    </form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import LastModifiedBy from './LastModifiedBy.vue';

export default {
  name: 'EmployeeModalForm',
  components: {
    LastModifiedBy,
  },
  computed: {
    isPermittedToSave() {
      return (!this.activeEmployee.EmployeeID
          && this.isPermittedAll(['EmployeesCreate']))
        || (this.activeEmployee.EmployeeID
          && this.isPermittedAll(['EmployeesUpdate']));
    },
    activeEmployee() {
      return this.$store.state.activeEmployee;
    },
    employeeModalFormOpen() {
      return this.$store.state.employeeModalFormOpen;
    },
    employeeTitle: {
      get() {
        return this.activeEmployee.EmployeeTitle;
      },
      set(employeeTitle) {
        if (employeeTitle) {
          this.activeEmployee.EmployeeTitle = _.cloneDeep(employeeTitle);
          this.activeEmployee.EmployeeTitleID = employeeTitle.EmployeeTitleID;
        }
      },
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    '$store.state.employeeModalFormOpen': function (open) {
      if (open) {
        this.refreshData();
      }
    },
  },
  methods: {
    closeEmployeeModal(skipDirtyCheck) {
      const confirm = () => {
        this.$store.commit('setEmployeeModalFormOpen', false);
        setTimeout(() => {
          this.$store.commit('setActiveEmployee');
        }, 500);
      };

      if (this.$store.getters.isActiveEmployeeDirty && !skipDirtyCheck) {
        this.showConfirm(
          'Are you sure you want to leave this employee without saving?',
          'You have unsaved changes',
        ).then(confirm, _.noop);
      } else {
        confirm();
      }
    },
    saveEmployee() {
      let promise = Promise.resolve();

      if (this.activeEmployee.EmployeeID) {
        promise = this.$store.dispatch('updateEmployee');
      } else {
        promise = this.$store.dispatch('createEmployee');
      }

      promise
        .then(() => this.closeEmployeeModal(true));
    },
    hideEmployee() {
      const confirm = () => {
        this.$store.dispatch('deleteEmployee')
          .then(() => {
            this.closeEmployeeModal(true);
          });
      };

      this.showConfirm(
        'Are you sure you want to hide this employee?',
        'Hide Employee',
      ).then(confirm, _.noop);
    },
    restoreEmployee() {
      const confirm = () => {
        this.$store.dispatch('restoreEmployee')
          .then(() => {
            this.closeEmployeeModal(true);
          });
      };

      this.showConfirm(
        'Are you sure you want to unhide this employee?',
        'Hide Employee',
      ).then(confirm, _.noop);
    },
    refreshData() {
      this.$store.dispatch('getEmployeeTitles');
    },
  },
};
</script>

<style lang="scss"></style>
